const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const _ = require("lodash");

const URLMake = require("../../shared/URLMake");
const withOfficeErrorCatching = require("../core/hoc/withOfficeErrorCatching");
const withSetURL = require("../core/hoc/withSetURL");
const SortableTable = require("./SortableTable");
const StatsIcon = require("../core/view/StatsIcon");
const ClassesUtil = require("./util/ClassesUtil");
const Link = require("../core/view/Link");
const CopyTable = require("./data/CopyTable");
const InfoIcon = require("../office/InfoIcon");

const styles = require("./styles/ReportClasses.css");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withOfficeErrorCatching(Component);
	Component = withSetURL(Component);
	return Component;
};

module.exports = augment(
	createReactClass({
		displayName: "ReportSchools",

		propTypes: {
			user: PT.object.isRequired,
			pageData: PT.object,
			classes: PT.object.isRequired,
			filters: PT.object,
			updateFilter: PT.func,

			// Injected by HOCs
			setURL: PT.func.isRequired,
		},

		renderTable: function(classes) {
			const {days} = this.props.filters;
			const groupedClasses = _.groupBy(
				_.filter(classes, "activeAndCurrent"),
				c => _.get(c, "school.id")
			);
			const columnNames = [
				"name",
				"classes",
				"students",
				"star",
				"trophy",
				"pc",
				"time",
			];
			let schoolsArr = _.map(groupedClasses, (sc, sid) => {
				const totalStats = ClassesUtil.totalSchoolStats(sc, days);
				const minutes = (totalStats.timeSpent || 0) / 60;
				const schoolName = _.get(sc, [0, "school", "displayName"]);
				return {
					name: (
						<Link
							to={URLMake.forSchool("reports", "classes", {schoolID: sid})}
							className={styles.link}
						>
							{schoolName}
						</Link>
					),
					nameValue: schoolName,
					classes: sc.length,
					students: _.sumBy(sc, c => c.studentIDs.length),
					star: totalStats.stars || 0,
					trophy: totalStats.trophies || 0,
					pc: totalStats.problemsCorrect || 0,
					time: ClassesUtil.timeToShortString(minutes),
				};
			});
			schoolsArr = _.sortBy(schoolsArr, c => _.toLower(c.name));

			const headers = {
				name: "School Name",
				classes: "Active Classes",
				students: "Active Students",
				star: (
					<StatsIcon type="star" style="office" className={styles.iconHeader} />
				),
				trophy: (
					<StatsIcon
						type="trophy"
						style="office"
						className={styles.iconHeader}
					/>
				),
				pc: (
					<StatsIcon
						type="check"
						style="office"
						className={styles.iconHeader}
					/>
				),
				time: (
					<StatsIcon type="time" style="office" className={styles.iconHeader} />
				),
			};
			const copy = CopyTable.getReportHeaderCopy("list");
			const categories = (
				<div className={styles.categoriesSchools + " header-reportSchoolList"}>
					<div className={styles.tbLeft + " " + styles.totals4}>
						<div className={styles.infoHeader}>
							<InfoIcon
								title={copy.total.title}
								text={copy.total.text}
								className={styles.infoIcon}
								isModal={true}
								modalClass={styles.infoModal}
								modalTextClass={styles.infoModalText}
							/>
							{copy.total.title}
						</div>
					</div>
				</div>
			);

			const sortFunctions = {
				time: body => {
					return _.sortBy(body, r =>
						ClassesUtil.timeStringToSeconds(r["time"])
					);
				},
				played: body => {
					return _.sortBy(body, r => ClassesUtil.getSortableDate(r["played"]));
				},
				name: body => _.sortBy(body, r => _.toLower(_.trim(r.nameValue))),
			};
			const headerClasses = {
				star: styles.statHeader + " " + styles.tbLeft,
				trophy: styles.statHeader,
				pc: styles.statHeader,
				time: styles.statHeader,
			};
			const bodyClasses = {
				played: styles.statPlayed,
				star: styles.statStar + " " + styles.tbLeft,
				trophy: styles.statTrophy,
				pc: styles.statPC,
				time: styles.statTime,
			};

			const widthClasses = {
				name: styles.nameWidth,
				classes: styles.teacherWidth,
				students: styles.studentWidth,
				star: styles.starWidth,
				trophy: styles.trophyWidth,
				pc: styles.pcWidth,
				time: styles.timeWidth,
			};

			return (
				<div className={styles.body}>
					<SortableTable
						tableID="reportSchoolList"
						columnNames={columnNames}
						headers={headers}
						sortableColumns={columnNames}
						initiallySortedBy="name"
						data={schoolsArr}
						sortFunctions={sortFunctions}
						bodyClasses={bodyClasses}
						widthClasses={widthClasses}
						headerClasses={headerClasses}
						extraHeader={categories}
						canScroll={true}
					/>
				</div>
			);
		},

		render: function() {
			const classes = this.props.classes;
			return <div className={styles.inner}>{this.renderTable(classes)}</div>;
		},
	})
);
